import React, {PropTypes,Component} from 'react';
import './style.less';
import mobx from 'mobx';
import Icon from '../Icon';
import InputItem from '../InputItem';

export default class InputRage extends Component {
  handleChange1 = (v) => {
    if (this.props.onChange){
      this.props.onChange([v, {text:this.props.value[1], value:this.props.value[1]}]);
    }
  }

  handleChange2 = (v) => {
    if (this.props.onChange){
      this.props.onChange([{text:this.props.value[0], value:this.props.value[0]}, v]);
    }
  }

  render() {
    const {
      value = [], onChange, ...other
    } = this.props;
    return (
      <div className='inputRage'>
        <InputItem value={value[0]} onChange={this.handleChange1} {...other}/>
        <div className='zhi'>至</div>
        <InputItem value={value[1]} onChange={this.handleChange2} {...other}/>
      </div>
    )
  }

}
